export default __webpack_public_path__ + "static/media/modelo.1c52c5b2.png";